import axiosInstance from './axiosInstance';
import { PAGINATION } from '../constants';

const multipartConfig = { headers: { 'Content-Type': 'multipart/form-data' } };

const api = {
  login: (username, password, platform = 'WEB') =>
    axiosInstance.post('/v1/user/login', { username, password, platform }),

  getMyAziende: () => axiosInstance.get('/v1/user/aziende'),
  getAzienda: () => axiosInstance.get('/azienda'),
  getAziendaByUser: (userId) => axiosInstance.get(`/azienda/user/${userId}`),
  updateAzienda: (data) => axiosInstance.put('/azienda', data),
  updateAziendaByUser: (userId, data) =>
    axiosInstance.put(`/azienda/user/${userId}`, data),

  listUsers: (page, size = PAGINATION.PAGE_SIZE) =>
    axiosInstance.get('/v1/user/list', { params: { page, size } }),
  toggleUserStatus: (userId, active) =>
    axiosInstance.put(`/v1/user/${userId}/status`, { active }),
  deleteUser: (userId) => axiosInstance.delete(`/v1/user/${userId}`),

  listEventi: (aziendaId, page, size = PAGINATION.PAGE_SIZE, sort = PAGINATION.DEFAULT_SORT, signal) =>
    axiosInstance.get(`/azienda/eventi/${aziendaId}`, {
      params: { page, size, sort },
      signal,
    }),
  toggleEventoStatus: (eventoId) =>
    axiosInstance.put(`/azienda/eventi/${eventoId}/stato`, {}),
  deleteEvento: (eventoId) =>
    axiosInstance.delete(`/azienda/eventi/${eventoId}`),

  getCategorie: () => axiosInstance.get('/eventi/tipologie'),
  getAziendaCategorie: () => axiosInstance.get('/util/aziende/category'),

  uploadProfileImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/azienda/uploadProfileImage', formData, multipartConfig);
  },
  uploadProfileImageByUser: (userId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post(`/azienda/uploadProfileImage/${userId}`, formData, multipartConfig);
  },
  uploadGallery: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return axiosInstance.post('/azienda/uploadGallery', formData, multipartConfig);
  },
  uploadGalleryByUser: (userId, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return axiosInstance.post(`/azienda/uploadGallery/${userId}`, formData, multipartConfig);
  },
  getGalleria: () => axiosInstance.get('/azienda/immagini'),
  getGalleriaByUser: (userId) =>
    axiosInstance.get(`/azienda/immagini/azienda/${userId}`),
  getProfileImageByUser: (userId) =>
    axiosInstance.get(`/azienda/immagini/profile/${userId}`),
  deleteImmagine: (idImmagine) =>
    axiosInstance.delete(`/azienda/immagini/${idImmagine}`),
};

export default api;
